var _path, _path2, _path3, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertsdistributionpermanufacturer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1236 5.41665C11.9576 3.9722 14.0424 3.9722 14.8764 5.41665L22.3819 18.4166C23.2159 19.861 22.1735 21.6666 20.5056 21.6666H5.49447C3.82657 21.6666 2.78413 19.861 3.61808 18.4166L11.1236 5.41665Z",
    stroke: "#5DA3E9",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42235 12.2643C8.45475 11.6674 8.95018 11.2 9.55041 11.2H10.1317C10.7319 11.2 11.2274 11.6674 11.2598 12.2643L11.6804 20.0143C11.7154 20.6585 11.2003 21.2 10.5524 21.2H9.12974C8.48186 21.2 7.96671 20.6585 8.00168 20.0143L8.42235 12.2643ZM9.55041 11.95C9.35033 11.95 9.18519 12.1058 9.17439 12.3048L8.75372 20.0548C8.74206 20.2695 8.91378 20.45 9.12974 20.45H10.5524C10.7683 20.45 10.9401 20.2695 10.9284 20.0548L10.5077 12.3048C10.4969 12.1058 10.3318 11.95 10.1317 11.95H9.55041Z",
    fill: "#5DA3E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7298 21.2H16.8703C17.4942 21.2 18 20.6964 18 20.075V13.2C18 13.0497 17.9099 12.914 17.771 12.855C17.6322 12.7961 17.4715 12.8254 17.3626 12.9295L14.8619 15.3202V13.2C14.8619 13.0547 14.7776 12.9225 14.6456 12.8607C14.5136 12.7989 14.3576 12.8185 14.2452 12.9111L11.9024 14.8419L11.953 15.7738L14.1088 13.9971V16.2C14.1088 16.3503 14.1989 16.4861 14.3377 16.545C14.4765 16.6039 14.6372 16.5746 14.7461 16.4706L17.2468 14.0799V20.075C17.2468 20.2821 17.0782 20.45 16.8703 20.45H16.3682V18.2C16.3682 17.7168 15.9748 17.325 15.4895 17.325H13.4812C12.9959 17.325 12.6025 17.7168 12.6025 18.2V20.45H12.1406C12.0726 20.7362 11.9283 20.994 11.7298 21.2ZM15.6151 18.2V20.325H13.3556V18.2C13.3556 18.131 13.4118 18.075 13.4812 18.075H15.4895C15.5589 18.075 15.6151 18.131 15.6151 18.2Z",
    fill: "#5DA3E9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.75,
    cy: 9.75,
    r: 0.75,
    fill: "#5DA3E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertsdistributionpermanufacturer);
export default __webpack_public_path__ + "static/media/Alerts distribution per manufacturer.ca81f2272ad86af7a7b4fa4c2f6d6b60.svg";
export { ForwardRef as ReactComponent };